import { useQuery } from '@tanstack/react-query';
import API from 'src/utils/apiConfig';
import { queryKeys } from 'src/api/queryKeys';

// Who may open the distributor overview is decided by the backend; the frontend only asks.
export const fetchFerreroOverviewAccess = async () => {
  const r = await API.get('/v1/ferrero/overview/access');
  return r.data?.success === true && r.data.allowed === true;
};

export const useFerreroOverviewAccess = (orgId) => useQuery({
  queryKey: queryKeys.ferreroOverviewAccess(orgId),
  queryFn: fetchFerreroOverviewAccess,
  // Only Ferrero has the page, so no other org spends a request on asking.
  enabled: orgId === 'Ferrero',
  staleTime: Infinity,
});

// Distributors ranked worst first, computed server-side from live device state plus ONE events-table
// query for the range. See backend bl/custom/ferreroOverview.ts.
export const fetchFerreroOverview = async (range) => {
  const r = await API.get('/v1/ferrero/overview', { params: { range } });
  if (!r.data?.success) throw new Error(r.data?.message || 'Failed to load the overview');
  return r.data.data;
};

export const useFerreroOverview = (orgId, range, enabled) => useQuery({
  queryKey: queryKeys.ferreroOverview(orgId, range),
  queryFn: () => fetchFerreroOverview(range),
  enabled: !!orgId && enabled,
  refetchInterval: 5 * 60 * 1000,
});
